import { OnDemandNode } from "../../OnDemandNode";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";
import { AutoUploadList } from "./AutoUploadList";

export class OnDemandAutoUploadList extends AutoUploadList {
    getOnDemandEntities():any{
        let entitiesArray: any[] = [];

        if (this.isLoaded) {
            this.children?.forEach((child: any) => {
                let onDemandEntity:any;
                if (child instanceof OnDemandNode) {
                onDemandEntity = child.getOnDemandEntity();
                } else if (child instanceof OnDemandAutoUploadNode) {
                onDemandEntity = child.getOnDemandEntities();
                }
                if (Array.isArray(onDemandEntity ) || Object.keys(onDemandEntity ).length !== 0) {
                    entitiesArray.push(onDemandEntity);
                }
            });
        }
        return entitiesArray;
    }
}
